module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAARCAYAAADkIz3lAAAAAXNSR0IArs4c6QAAAJFJREFUKBVjnDlzpjIjI2PC////F6Snp99lwAGYoJJ7gPInZ82aZY9DHQMjTAKkCGjqWqDpwWlpaQdh4jAarhAkgE8xikJ8ijEU4lKMVSE2xTgVoivGqxCq2ApIV+NViBwKOBUiKwKFK1aF6IpATsBQiE0RhkJcilAU4lMEV0hIEUghCyg9AmkXIDYH+g5negQAvyF4zzHdIZIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Line Copy 8.png
// module id = dBVu
// module chunks = 1